import React from 'react';
import PropTypes from 'prop-types';
import Translation from '../translation/translation';
import toDangerousReactHtml from '../../helper/to_dangerous_react_html';
import { loadGoogleMapDependencies } from '../../../_global/initGoogleMapDependencies';

function LightBoxUILockContent(props) {
    return (
        <div className="finder-container" style={{ textAlign: 'center', position: 'relative', top: '15px' }}>
            {props.loaded && <>
                <Translation
                    translationKey="fsf-loading-message"
                    className="fs-remove-light-box-header__headline"
                />
                <img src="https://static.tyroola.com/images/misc/loading-spinner.gif" />
            </>}

            {!props.loaded && <>
                <Translation
                    tagName="p"
                    translationKey="generic-error-message"
                    placeholder={{
                        'SUPPORT_NUMBER_LINK': TYROOLA.globals.supportNumberLink,
                        'SUPPORT_NUMBER': TYROOLA.globals.supportNumber,
                        'SUPPORT_EMAIL': TYROOLA.globals.supportEmail
                    }}
                    className="fs-remove-light-box-header__headline"
                />

                <div className="fs-remove-light-box-content__actions">
                    <Translation
                        tagName="button"
                        className="fs-remove-light-box-content__action-accept"
                        onClick={loadGoogleMapDependencies}
                        translationKey="fsf-loading-failed-try-again"
                    />
                </div>
            </>
            }
        </div>
    );
}

export { LightBoxUILockContent };
